import React, { forwardRef, useEffect, useState } from "react";

const PrintPoInvoice = forwardRef((props, ref) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    setData(props?.data);
  }, [props]);

  const styles = {
    container: { fontFamily: "Arial", fontSize: "14px", margin: "20px" },
    h2: { textAlign: "center", textTransform: "uppercase", margin: "5px 0" },
    table: { width: "100%", borderCollapse: "collapse", marginBottom: "10px" },
    th: {
      border: "1px solid #000",
      padding: "4px",
      textAlign: "left",
      backgroundColor: "#f2f2f2",
    },
    td: { border: "1px solid #000", padding: "4px", textAlign: "left" },
    sectionTitle: {
      backgroundColor: "#ddd",
      fontWeight: "bold",
      padding: "4px",
      margin: "10px 0",
    },
    textRight: { textAlign: "right" },
    textCenter: { textAlign: "center" },
    noBorder: { border: "none" },
  };

  const printbody = {
    display: "flex",
    flexDirection: "column",
    margin: "10px",
  };

  const totals = (data?.items || []).reduce(
    (acc, item) => {
      acc.purchaseQuantity += Number(item.purchaseQuantity);
      acc.orderPriceUnit += Number(item.orderPriceUnit);
      acc.netValue += Number(item.netValue);
      acc.taxAmount += Number(item.taxAmount);
      return acc;
    },
    { purchaseQuantity: 0, orderPriceUnit: 0, netValue: 0, taxAmount: 0 }
  );

  return (
    <div ref={ref} style={printbody} className="m-4">
      <div style={styles.container}>
        <h2 style={styles.h2}>PO Invoice</h2>

        <div style={styles.sectionTitle}>Invoice Details</div>
        <table style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.td}>
                <strong>Date:</strong> {data.purchasingDocumentDate}
              </td>
              <td style={styles.td}>
                <strong>Purchase Order No:</strong> {data.purchasingDocumentNr}
              </td>
            </tr>
            <tr>
              <td style={styles.td} colSpan="3">
                <strong>Purchasing Document Type:</strong>{" "}
                {data.purchasingDocumentType}
              </td>
            </tr>
            <tr>
              <td style={styles.td}>
                <strong>Vendor:</strong> {data.vendorName} ({data.vendorCode})
              </td>
              <td style={styles.td} colSpan="2">
                <strong>Company:</strong> {data.companyCodeDesc} (
                {data.companyCodeCode})
              </td>
            </tr>
            <tr>
              <td style={styles.td} colSpan="3">
                <strong>Inco Terms:</strong> {data.incoTermsDesc}, Location:{" "}
                {data.incoTermsLocation}
              </td>
            </tr>
          </tbody>
        </table>

        <div style={styles.sectionTitle}>Buyer & Vendor</div>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Buyer (Bill To)</th>
              <th style={styles.th}> Vendor</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={styles.td}>
                {data.companyCodeDesc}
                <br />
                Company Code: {data.companyCodeCode}
                <br />
                Payment Terms: {data.paymentTerms}
              </td>
              <td style={styles.td}>
                {data.vendorName}
                <br />
                Vendor Code: {data.vendorCode}
                <br />
                Payment Terms: {data.paymentTerms}
              </td>
            </tr>
          </tbody>
        </table>

        <div style={styles.sectionTitle}>Line Items</div>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>S.No</th>
              <th style={styles.th}>Material Code</th>
              <th style={styles.th}>Description</th>
              <th style={styles.th}>Quantity</th>
              <th style={styles.th}>Unit</th>
              <th style={styles.th}>Unit Price</th>
              <th style={styles.th}>Net Value</th>
              <th style={styles.th}>Tax Amount</th>
              <th style={styles.th}>Delivery Date</th>
            </tr>
          </thead>
          <tbody>
            {data?.items &&
              data?.items.map((item, idx) => (
                <tr key={idx}>
                  <td style={styles.td}>{idx + 1}</td>
                  <td style={styles.td}>{item.materialCode}</td>
                  <td style={styles.td}>{item.materialDescription}</td>
                  <td style={styles.td}>{item.purchaseQuantity}</td>
                  <td style={styles.td}>{item.orderUnitOfMeasure}</td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {item.orderPriceUnit}
                  </td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {item.netValue}
                  </td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {item.taxAmount}
                  </td>
                  <td style={styles.td}>{item.deliveryDate}</td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr>
              <td style={{ ...styles.td, ...styles.textRight }} colSpan="6">
                <strong>Total</strong>
              </td>
              <td style={{ ...styles.td, textAlign: "right" }}>{totals.netValue}</td>
              <td style={{ ...styles.td, textAlign: "right" }}>{totals.taxAmount}</td>
              <td style={styles.td}></td>
            </tr>
          </tfoot>
        </table>

        <div style={styles.sectionTitle}>Summary</div>
        <table style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.td}>
                <strong>Total Item Value:</strong> ₹{totals.netValue}
              </td>
              <td style={styles.td}>
                <strong>Total Tax:</strong> ₹{totals.taxAmount}
              </td>
              <td style={styles.td}>
                <strong>Grand Total:</strong> ₹
                {totals.taxAmount + totals.netValue}
              </td>
            </tr>
          </tbody>
        </table>

        <div style={styles.sectionTitle}>Remarks</div>
        <p>{data.purchasingRemark}</p>

        <div style={styles.sectionTitle}>Declaration</div>
        <ul>
          <li>Goods once sold cannot be taken back or exchanged.</li>
          <li>We are not responsible for material damaged in transit.</li>
          <li>
            Payment should be made to our company as per agreed credit terms.
          </li>
        </ul>

        <div style={{ ...styles.textRight, marginTop: "30px" }}>
          <p>
            For <strong>{data.vendorName}</strong>
          </p>
          <p>
            <br />
            <br />
            Authorised Signatory
          </p>
        </div>
      </div>
    </div>
  );
});

export default PrintPoInvoice;
